import request from "@/utils/http";

/**
 * 注册
 * username password confirmPassword mobile code mail company companyContact
 * @param {*} data
 * @returns
 */
export function registerApi(data) {
  return request("/mall/login/register", {
    method: "POST",
    data,
  });
}

/**
 * 获取验证码
 * @returns
 */
export function getLoginCodeApi(mobile) {
  return request("/mall/login/getCode" + "?mobile=" + mobile, {
    method: "GET",
  });
}

/**
 * 验证手机和验证码
 * @param {*} userName
 * @param {*} password
 * @returns
 */
export function codeLoginApi(mobile, code) {
  return request("/mall/login/code", {
    method: "POST",
    data: {
      mobile,
      code,
    },
  });
}

/**
 * 邮箱登录
 * @param {*} mail
 * @param {*} password
 * @returns
 */
export function passwordLoginApi(mail, password) {
  return request("/mall/login/passwordLogin", {
    method: "POST",
    data: {
      mail:mail,
      password:password,
    },
  });
}

/**
 * 退出登录
 * @returns
 */
export function logOutApi() {
  return request("/mall/login/logOut", {
    method: "GET",
  });
}

/**
 * 修改密码
 * @returns
 */
export function updatePassword(data) {
  return request("/mall/user/updatePassword", {
    method: "POST",
    data,
  });
}

/**
 * 验证手机和验证码单选
 * @param {*} userName
 * @param {*} password
 * @returns
 */
export function phoneMailLoginApi(mobile, mail) {
  return request("/mall/login/phoneMail", {
    method: "POST",
    data: {
      mobile:mobile,
      mail:mail,
    },
  });
}

/**
 * 修改用户名
 * @returns
 */
export function updateUserInfo(data) {
  return request("/mall/user/updateUserInfo", {
    method: "POST",
    data,
  });
}
